<script setup>
import { computed } from 'vue';
import ConfigurationRadioSelection from '../../ConfigurationRadioSelection';
import ConfigurationCheckSelection from '../../ConfigurationCheckSelection';
import { useMainStore } from '../../../store/index.js';

import '../../../styles/configurator-section.css';
import '../../../styles/configurator-selection.css';

const store = useMainStore();

const emit = defineEmits(['select']);

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  images: {
    type: Object,
    default: null,
  },
});

const interiorstylingPackage = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'interiorstylingPackage');
});
const infotainmentPackage = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'infotainmentPackage');
});
const comfortPackage = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'comfortPackage');
});

// extras product options
const extras = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'extras');
});
const extras1 = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'extras1');
});
const extras2 = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'extras2');
});
const extras3 = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'extras3');
});
const extras4 = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'extras4');
});
const extras5 = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'extras5');
});
const extras6 = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'extras6');
});
</script>

<template>
  <section
    v-if="props.items"
    id="styling-comfort"
    class="configurator-section"
  >
    <h2>{{ $i18n('stylingComfortHeaderTitle') }}</h2>
    <div class="configurator-section__image">
      <img
        :src="props.images?.dashboard"
        alt="Truck - front side view"
      >
      <img
        :src="props.images?.interior"
        alt="Truck - front side view"
      >
    </div>
    <h3>{{ $i18n('extras') }}</h3>
    <div class="configurator-section__row">
      <ConfigurationCheckSelection
        v-if="extras"
        v-model="store.selected.stylingComfort[extras.id]"
        :type="extras.id"
        :options="extras.options"
        @select="emit('select', $event)"
      />
      <ConfigurationCheckSelection
        v-if="extras1"
        v-model="store.selected.stylingComfort[extras1.id]"
        :type="extras1.id"
        :options="extras1.options"
        @select="emit('select', $event)" 
      />
    </div>
    <div class="configurator-section__row">
      <ConfigurationCheckSelection
        v-if="extras2"
        v-model="store.selected.stylingComfort[extras2.id]"
        :type="extras2.id"
        :options="extras2.options"
        @select="emit('select', $event)"
      />
      <ConfigurationCheckSelection
        v-if="extras3"
        v-model="store.selected.stylingComfort[extras3.id]"
        :type="extras3.id"
        :options="extras3.options"
        @select="emit('select', $event)" 
      />
    </div>
    <div class="configurator-section__row">
      <ConfigurationCheckSelection
        v-if="extras4"
        v-model="store.selected.stylingComfort[extras4.id]"
        :type="extras4.id"
        :options="extras4.options"
        @select="emit('select', $event)"
      />
      <ConfigurationCheckSelection
        v-if="extras5"
        v-model="store.selected.stylingComfort[extras5.id]"
        :type="extras5.id"
        :options="extras5.options"
        @select="emit('select', $event)"
      />
    </div>
    <div class="configurator-section__row">
      <ConfigurationCheckSelection
        v-if="extras6"
        v-model="store.selected.stylingComfort[extras6.id]"
        :type="extras6.id"
        :options="extras6.options"
        @select="emit('select', $event)"
      />
    </div>
  </section>
</template>

<style scoped>
  .configurator-section__image {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 2em;
    max-width: 100%;
  }
  .configurator-section__image img {
    width: 40%;
  }
  .sdds-divider-dark-vertical {
    height: var(--sdds-spacing-layout-128);
    align-self: center;
  }
  .configurator-selection__checkoption {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 30em;
    height: 100%;
    width: 100%;
  }

  @media only screen and (max-width: 1000px) {
    .configurator-section__image {
      gap: 1em;
      max-width: 90%;
    }
    .sdds-divider-dark-vertical {
      display: none;
    }
    .configurator-section__row {
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 500px) {
    .configurator-section__image {
      flex-direction: column;
      align-items: center;
    }
    .configurator-section__image img {
      width: 90%;
    }
  }
</style>
